export enum ThemeEnum {
    dark = 'dark',
}

export interface ITheme {
    colors: {
        white: string,
        accentColor: string,
        background: string,
        backgroundHeader: string,
        backgroundHeaderOpacity: string,
        textSecondary: string,
        elementsGrey: string,
        backgroundElemetsBlack: string,
        backgroundWaze: string,
        backgroundBlack: string,
}}
